import PageHeader from "@/components/PageHeader";
import CtaBand from "@/components/CtaBand";
import { FadeUp, Overline } from "@/components/Reveal";

const GROUPS = [
  {
    title: "Trades & Construction",
    img: "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?q=80&w=1600&auto=format&fit=crop",
    alt: "Wall of woodworking tools in a workshop",
    items: ["Construction", "Landscaping", "Plumbing", "Electrical", "HVAC"],
    testid: "industries-card-trades",
  },
  {
    title: "Real Estate & Property",
    img: "https://images.unsplash.com/photo-1633697457191-ac104253fe20?q=80&w=1600&auto=format&fit=crop",
    alt: "Red farmhouse surrounded by trees in Pennsylvania",
    items: ["Rental Properties", "Property Management"],
    testid: "industries-card-real-estate",
  },
  {
    title: "Professional & Service Businesses",
    img: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=1600&auto=format&fit=crop",
    alt: "Salon owner working with a client",
    items: ["Salons", "IT / Technology", "Senior Transition Services", "Biotech"],
    testid: "industries-card-professional",
  },
  {
    title: "Retail & Product-Based Businesses",
    img: "https://images.unsplash.com/photo-1769107805465-bfd41863f1a0?q=80&w=1600&auto=format&fit=crop",
    alt: "Small retail boutique with clothing racks",
    items: ["Screen Printing", "Retail", "Food Trucks", "Automotive / Car Lots"],
    testid: "industries-card-retail",
  },
  {
    title: "Other Industries",
    img: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?q=80&w=1600&auto=format&fit=crop",
    alt: "Craftsman's workbench in a workshop",
    items: ["Churches and nonprofit organizations", "Manufacturing", "Trucking & Logistics"],
    testid: "industries-card-other",
    wide: true,
  },
];

export default function Industries() {
  return (
    <div>
      <PageHeader
        testid="industries-header"
        overline="Industries"
        lines={["Industries & businesses", "we understand."]}
        intro="Every industry keeps its books a little differently. A landscaping company, rental property owner, salon, contractor, and retail business can have very different accounting needs — and that changes how the books should be kept."
      />

      <section className="pb-24" data-testid="industries-grid-section">
        <div className="mx-auto max-w-7xl px-6">
          <FadeUp>
            <Overline>Who we serve</Overline>
          </FadeUp>
          <div className="mt-8 grid gap-6 md:grid-cols-2">
            {GROUPS.map((g, i) => (
              <FadeUp
                key={g.title}
                delay={(i % 2) * 0.08}
                className={`h-full ${g.wide ? "md:col-span-2" : ""}`}
              >
                <div
                  data-testid={g.testid}
                  className={`group flex h-full overflow-hidden rounded-2xl border border-hairline bg-white transition-shadow duration-300 hover:shadow-xl ${
                    g.wide ? "flex-col sm:flex-row" : "flex-col"
                  }`}
                >
                  <div className={g.wide ? "sm:w-2/5 shrink-0" : ""}>
                    <img
                      src={g.img}
                      alt={g.alt}
                      className={`w-full object-cover transition-transform duration-500 group-hover:scale-[1.03] ${
                        g.wide ? "h-52 sm:h-full" : "h-52"
                      }`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-8">
                    <h2 className="font-serif text-2xl font-semibold text-ink sm:text-3xl">{g.title}</h2>
                    <ul className={`mt-5 flex-1 ${g.wide ? "grid gap-2 sm:grid-cols-3" : "space-y-2"}`}>
                      {g.items.map((it) => (
                        <li key={it} className="flex items-center gap-2.5 text-sm text-stone2">
                          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                          {it}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
